import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Info from '@material-ui/icons/InfoOutlined';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { fetchSchedules, deleteSchedule, updateScheduleName } from '../../store/actions/schedule';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';
import ScheduleDialog from '../../components/Schedule/ScheduleDialog';
import Input from '../../components/Input/Input';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  hint: {
    top: '41px',
    left: '5px',
    position: 'relative',
  },
});

class Schedules extends React.Component {
  state = {
    validaetPremium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
    modalPremium: false,
    deleteModal: false,
    scheduleModal: false,
    editModal: false,
    editName: '',
    horaryClosing: '',
    isToConsiderClockInDelay: false,
    considerNightHoursCorrectedInBankHour: false,
    hasBankHourLimit: false,
    specialHoursSundayAndHoliday: false,
    maxAccumulatedPositiveTolerance: '',
    maxCreditToBankOfHours: '',
    specialHoursAfterMinutes: '',
    clockInNegativeTolerance: '',
    clockInPositiveTolerance: '',
    clockOutNegativeTolerance: '',
    clockOutPositiveTolerance: '',
    onToleranceModal: false,
    currentSchedule: {
      workingDay: {
        description: '',
        isRotation: false,
        category: 'DAYS',
        amountWork: 1,
        amountLoose: 1,
        scaleZero: null
      },
      shifts: [
        {
          days: [],
          shiftsTurns: {},
        },
      ],
    },
    isMounted: false
  };

  componentDidMount() {
    this.props.onFetchSchedules();
  }

  closeModalPremium = () => {
    this.setState({ modalPremium: false });
  }

  closeToleranceModal = () => {
    this.setState({ onToleranceModal: false })
  }

  newMinutes = (minute) => {
    const minutes = minute >= 60 ? minute % 60 : minute // Valor fornecido por outra variável
    const hoursMinutes = minute >= 60 ? minute / 60 : 0
    const referenceDate = new Date();
    referenceDate.setHours(hoursMinutes, minutes, 0, 0); // Define a data de referência com a hora '00:10'
    const x = []
    return referenceDate
  }

  handleActionClick = (action, item) => {
    const currentSchedule = this.props.schedules.find(schedule => schedule.workingDay.id === item);
    if (action === 'Excluir') {
      this.setState({ deleteModal: true, currentSchedule });
    } else if (action === 'Editar') {
      this.setState({
        editModal: true,
        currentSchedule,
        editName: currentSchedule.workingDay.description,
        horaryClosing: currentSchedule.workingDay.horaryClosing,
        isToConsiderClockInDelay: currentSchedule.shifts[0] ? currentSchedule.shifts[0].shiftsTurns.isToConsiderClockInDelay : null,
        considerNightHoursCorrectedInBankHour: currentSchedule.workingDay.considerNightHoursCorrectedInBankHour,
        hasBankHourLimit: currentSchedule.workingDay.hasBankHourLimit,
        specialHoursSundayAndHoliday: currentSchedule.workingDay.specialHoursSundayAndHoliday,
        maxAccumulatedPositiveTolerance: this.newMinutes(currentSchedule.workingDay.maxAccumulatedPositiveTolerance),
        maxCreditToBankOfHours: this.newMinutes(currentSchedule.workingDay.maxCreditToBankOfHours),
        specialHoursAfterMinutes: this.newMinutes(currentSchedule.workingDay.specialHoursAfterMinutes),
        clockInNegativeTolerance: currentSchedule.shifts[0] ? this.newMinutes(currentSchedule.shifts[0].shiftsTurns.clockInNegativeTolerance) : '',
        clockInPositiveTolerance: currentSchedule.shifts[0] ? this.newMinutes(currentSchedule.shifts[0].shiftsTurns.clockInPositiveTolerance) : '',
        clockOutNegativeTolerance: currentSchedule.shifts[0] ? this.newMinutes(currentSchedule.shifts[0].shiftsTurns.clockOutNegativeTolerance) : '',
        clockOutPositiveTolerance: currentSchedule.shifts[0] ? this.newMinutes(currentSchedule.shifts[0].shiftsTurns.clockOutPositiveTolerance) : ''
      });
    } else {
      this.setState({ scheduleModal: true, currentSchedule });
    }
  };



  handleActionCancel = () => {
    this.setState({ deleteModal: false, scheduleModal: false, editModal: false });
  };

  handleScaleZero = (value) => {
    this.setState({ scaleZero: value });
  };

  handleDeleteConfirm = () => {
    this.props.onDeleteSchedule(this.state.currentSchedule.workingDay.id);
    this.handleActionCancel();
  };


  handleChangeInput(event, fieldName) {
    // Verificar se o componente ainda está montado antes de atualizar o estado
    this.setState({ [fieldName]: event });
  }


  handleChange = (event, type) => {

    switch (type) {
      case 'scale':
        this.setState({ editName: event.target.value });
        break;

      case 'closingHour':
        if (event != 'Invalid Date' && event != null) {
          let newatime = { ...this.state.horaryClosing };
          newatime = event;
          this.setState({ horaryClosing: format(newatime, 'HH:mm:ss') });
        }
        break;

      default:
        break;
    }
  };

  handleEditConfirm = () => {
    const data = {
      id: this.state.currentSchedule.workingDay.id,
      description: this.state.editName,
      horaryClosing: this.state.horaryClosing,
      isToConsiderClockInDelay: this.state.isToConsiderClockInDelay,
      considerNightHoursCorrectedInBankHour: this.state.considerNightHoursCorrectedInBankHour,
      hasBankHourLimit: this.state.hasBankHourLimit,
      specialHoursSundayAndHoliday: this.state.specialHoursSundayAndHoliday,
      maxAccumulatedPositiveTolerance: new Date(this.state.maxAccumulatedPositiveTolerance).getMinutes(),
      maxCreditToBankOfHours: new Date(this.state.maxCreditToBankOfHours).getHours() * 60 + new Date(this.state.maxCreditToBankOfHours).getMinutes(),
      specialHoursAfterMinutes: new Date(this.state.specialHoursAfterMinutes).getHours() * 60 + new Date(this.state.specialHoursAfterMinutes).getMinutes(),
      clockInNegativeTolerance: new Date(this.state.clockInNegativeTolerance).getMinutes(),
      clockInPositiveTolerance: new Date(this.state.clockInPositiveTolerance).getMinutes(),
      clockOutNegativeTolerance: new Date(this.state.clockOutNegativeTolerance).getMinutes(),
      clockOutPositiveTolerance: new Date(this.state.clockOutPositiveTolerance).getMinutes()
    }
    this.props.onUpdateScheduleName(data);
    this.setState({ editName: '', horaryClosing: '' });
    this.handleActionCancel();

  };


  render() {
    const { schedules, loading, classes } = this.props;
    const {
      deleteModal,
      scheduleModal,
      currentSchedule,
      editName,
      editModal,
    } = this.state;

    const columns = [{ name: 'description', label: 'Descrição' }];

    // console.log('state', this.state)

    const actions = [
      {
        name: 'Visualizar',
        icon: VisibilityIcon,
        onClick: item => this.handleActionClick('Visualizar', item.id),
      },
      {
        name: 'Excluir',
        icon: DeleteIcon,
        onClick: item => this.handleActionClick('Excluir', item.id),
      },

      {
        name: 'Editar',
        icon: EditIcon,
        onClick: item => this.handleActionClick('Editar', item.id),
      },
    ];

    const maxAccumulatedPositiveTolerance = [
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'maxAccumulatedPositiveTolerance',
          label: 'Atraso máximo permitido do dia',
          required: false,
        }
      },
      {
        elementType: 'timePicker',
        config: {
          name: 'maxCreditToBankOfHours',
          label: 'Crédito máximo banco de horas',
          required: false,
        },
      },
      {
        elementType: 'timePicker',
        config: {
          name: 'specialHoursAfterMinutes',
          label: 'Horas extras especiais após horário definido',
          required: false,
        },
      }
    ]

    const toleranceConfig = [
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockInNegativeTolerance',
          label: 'Tolerância negativa entrada',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockInPositiveTolerance',
          label: 'Tolerância positiva entrada',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockOutNegativeTolerance',
          label: 'Tolerância negativa saída',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockOutPositiveTolerance',
          label: 'Tolerância positiva saída',
          required: false,
        }
      },
    ]

    const collator = new Intl.Collator('pt-Br', { numeric: true, sensitivity: 'base' });
    const schedulesAlp = schedules.map(schedule => schedule.workingDay)
    const schedulesAlphabetical = schedulesAlp.sort((a, b) => {
      if (a.description < b.description) {
        return -1;
      }
      if (a.description > b.description) {
        return 1;
      }
      return 0;
    });

    const userIdSuporte = JSON.parse(localStorage.getItem('companies'))[0].userId
    const suportSchudeleConfig = userIdSuporte == 33920 || userIdSuporte == 2005 || userIdSuporte == 35802 || userIdSuporte == 50639 || userIdSuporte == 53230 || userIdSuporte == 58886 || userIdSuporte == 63485 || userIdSuporte == 74697 || userIdSuporte == 75892 || userIdSuporte == 77251

    return (
      <React.Fragment>
        <ContentHeader
          title="Listagem de Escalas"
          subtitle="Listagem com as escalas cadastradas pela empresa"
        >
          {this.state.validaetPremium ?
            <Button onClick={() => this.props.history.push('/escalas/cadastrar')} variant="contained" color="primary">
              <AddIcon /> ADICIONAR
            </Button>
            :
            <Button
              onClick={() => this.props.history.push('/escalas/cadastrar')}
              variant="contained" color="primary">
              <AddIcon /> ADICIONAR
            </Button>
          }
          <Dialog
            open={this.state.modalPremium}
            onClose={this.closeModalPremium}
          >
            <DialogTitle>Atenção</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Typography color="primary" className={classes.premium}>
                  Seja assinante e adicione quantas escalas precisar.
                </Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => this.closeModalPremium()}>
                Fechar
              </Button>
              <Button component={Link} to="/assinatura" onClick={this.handleClose} variant="contained" color="primary" autoFocus>
                Assinar
              </Button>
            </DialogActions>
          </Dialog>
        </ContentHeader>

        <Paper elevation={2}>
          <DataTable
            rows={schedulesAlphabetical}
            columns={columns}
            actions={actions}
            loading={loading}
          />
        </Paper>

        <ScheduleDialog
          open={scheduleModal}
          onClose={this.handleActionCancel}
          schedule={currentSchedule}
          scaleZero={this.handleScaleZero}
          flexibleScale={this.state.currentSchedule.workingDay.scaleZero}
        />

        <Dialog open={deleteModal} onClose={this.handleActionCancel}>
          <DialogTitle>Excluir escala</DialogTitle>
          <DialogContent>
            <DialogContentText>Você tem certeza que deseja efetuar esta ação?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button onClick={this.handleDeleteConfirm} variant="contained" color="primary" autoFocus>
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.onToleranceModal} onClose={() => this.closeToleranceModal()} scroll='body' >
          <DialogTitle style={{ "textAlign": 'center' }}>Editar Tolerância</DialogTitle>
          <div style={{ width: '350px' }}>
            <Grid container justifyContent="center">
              {toleranceConfig.map(field => (
                <Grid item key={field.config.name}>
                  <Input
                    {...field.config}
                    elementType={field.elementType}
                    value={this.state[field.config.name]}
                    onChange={event => this.handleChangeInput(event, field.config.name)}
                    label={<Typography variant="caption" style={{ fontSize: '14px' }} noWrap>{field.config.label}</Typography>}
                    style={{ width: '250px' }}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
          <DialogActions justifyContent="center">
            <Button onClick={() => this.closeToleranceModal()}>CANCELAR</Button>
            <Button variant="contained" onClick={() => this.closeToleranceModal()} color="primary" type="submit" autoFocus >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={editModal} onClose={this.handleActionCancel} scroll='body'>
          <DialogTitle>Editar escala</DialogTitle>
          <DialogContent>
            <DialogContentText>Por favor, preencha o campo a seguir com o nome da escala
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              name="name"
              label="Escala"
              type="text"
              onChange={event => this.handleChange(event, 'scale')}
              value={editName}
              fullWidth
              required
            />
            {/* <Input
              elementType="timePicker"
              style={{ marginTop: '20px' }}
              label="Término do dia:"
              required={false}
              onChange={event => this.handleChange(event, 'closingHour')}
              value={`Fri Oct 02 2020 ${this.state.horaryClosing} GMT-0300 (Horário Padrão de Brasília)`}
            />
            <Tooltip title="Jornadas iniciadas antes deste horário serão consideradas pertencentes ao dia anterior. Para ter aderência as regras da CLT sugerimos que esse horário seja pelo menos 11h depois do término do último turno." >
              <span className={classes.hint}> <Info color="primary" /> </span>
            </Tooltip> */}

            {suportSchudeleConfig && (
              <React.Fragment>
                <Grid item xs={12} sm={4}>
                  <Button variant="contained" onClick={() => this.setState({ onToleranceModal: true })} color="primary" size="small" style={{ 'width': '230px' }}>
                    Editar Tolerância
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        name={'isToConsiderClockInDelay'}
                        checked={this.state.isToConsiderClockInDelay}
                        onChange={event => this.setState({ isToConsiderClockInDelay: event.target.checked })}
                      />
                    }
                    label={<Typography noWrap>Tolerância na intrajornada</Typography>}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        name={'considerNightHoursCorrectedInBankHour'}
                        checked={this.state.considerNightHoursCorrectedInBankHour}
                        onChange={event => this.setState({ considerNightHoursCorrectedInBankHour: event.target.checked })}
                      />
                    }
                    label={
                      <Typography noWrap>
                        Conversão da hora noturna
                      </Typography>
                    }
                  ></FormControlLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        name={'hasBankHourLimit'}
                        checked={this.state.hasBankHourLimit}
                        onChange={event => this.setState({ hasBankHourLimit: event.target.checked })}
                      />
                    }
                    label={
                      <Typography noWrap>
                        Limite de horas excedentes
                      </Typography>
                    }
                  ></FormControlLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        name={'specialHoursSundayAndHoliday'}
                        checked={this.state.specialHoursSundayAndHoliday}
                        onChange={event => this.setState({ specialHoursSundayAndHoliday: event.target.checked })}
                      />
                    }
                    label={
                      <Typography noWrap>
                        Considerar hora extra especial aos domingos e feriados
                      </Typography>
                    }
                  ></FormControlLabel>
                </Grid>
                {maxAccumulatedPositiveTolerance.map(field => (
                  <Grid item key={field.config.name}>
                    <Input
                      {...field.config}
                      elementType={field.elementType}
                      value={this.state[field.config.name]}
                      onChange={event => this.handleChangeInput(event, field.config.name)}
                      label={<Typography variant="caption" style={{ fontSize: '14px' }} noWrap>{field.config.label}</Typography>}
                      style={{ width: '350px' }}
                    />
                  </Grid>
                ))}
              </React.Fragment>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button variant="contained" color="primary" type="submit" onClick={this.handleEditConfirm} autoFocus >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment >
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  schedules: state.schedule.schedules,
});

const mapDispatchToProps = dispatch => ({
  onFetchSchedules: () => dispatch(fetchSchedules()),
  onDeleteSchedule: id => dispatch(deleteSchedule(id)),
  onUpdateScheduleName: (data) => dispatch(updateScheduleName(data)),
});

Schedules.propTypes = {
  schedules: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onFetchSchedules: PropTypes.func.isRequired,
  onDeleteSchedule: PropTypes.func.isRequired,
  onUpdateScheduleName: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps,)(withStyles(styles)(Schedules));
